import { render, staticRenderFns } from "./evrak.vue?vue&type=template&id=d3f5f442"
import script from "./evrak.vue?vue&type=script&lang=js"
export * from "./evrak.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports